var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotaCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8888 49.3944C57.3245 44.1646 60 37.3947 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C35.6612 60 40.9562 58.4319 45.4742 55.7064L30.0187 40.3141L23.0665 47.264L16.1566 40.2707L23.0618 33.3855L22.9944 33.3184L29.8856 26.4852L29.9338 26.5332L36.8692 19.618L43.8058 26.5316L36.882 33.453L52.8888 49.3944Z",
    fill: "#F1A43A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotaCell);
export default __webpack_public_path__ + "static/media/cota_cell.283fa1ef5b4d89e804049e043ea7c072.svg";
export { ForwardRef as ReactComponent };